import { isEmpty } from "lodash";

const isRememberMe = (isRemember, id) => {
  let rememberInfo = {
    id: id,
    isRemember: isRemember,
  };

  if (isRemember && !isEmpty(id)) {
    setRememberInfo(rememberInfo);
  } else {
    rememberInfo = {
      id: "",
      isRemember: false,
    };
    setRememberInfo(rememberInfo);
  }
};

const setRememberInfo = (remember) => {
  localStorage.setItem("rememberInfo", JSON.stringify(remember));
};

const getRememberInfo = () => {
  let rememberInfo = JSON.parse(localStorage.getItem("rememberInfo"));
  if (isEmpty(rememberInfo)) {
    rememberInfo = {
      id: "",
      isRemember: "",
    };
  }

  return rememberInfo;
};

export { setRememberInfo, getRememberInfo, isRememberMe };
